import React, { useEffect, useState, useRef } from "react";
import Link from "@components/_Revamp/Link";
import { Card } from "@components/_Revamp/StyledComponent";
import { styled } from "@linaria/react";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import { useHistory } from "react-router-dom";
import { themeDefault } from "src/theme-revamp";
import DeclarationModal from "@pages/ShieldStarter/Components/Modals/DeclarationModal";
import {
  PRODUCT_SUMMARY_SHIELD_STARTER,
  PRODUCT_SUMMARY_SHIELD_STARTER_HEALTH_PLUS,
  SHIELD_STARTER_DECLARATION_LINK,
  SHIELD_STARTER_HELTH_PLUS,
  TERMS_AND_CONDITION_SHIELD_STARTER,
  TERMS_AND_CONDITION_SHIELD_STARTER_HEALTH_PLUS,
} from "@static/staticConstents";
import { updateDeclaration } from "@redux/slices/SHIELD_STARTER/step4Slice";
import { calculateSpacer } from "@utils/spaceCalculation";
import { SCREEN_SIZE } from "@static/screen-size";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";
import { isEmpty } from "lodash";
import useReduxReset from "@pages/ShieldStarter/Helpers/useReduxReset";

const Header = styled.div<{ marginTop?: string }>`
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  text-align: center;
  color: #434343;
  font-size: 18px;
  margin-top: 0;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 28px;
    margin-top: ${(prop) => prop.marginTop || "24"}px;
  }
`;

const Description = styled.div`
  font-family: "Open Sans";
  font-style: normal;
  max-width: 588px;
  line-height: 140%;
  text-align: center;
  margin-top: 16px;
  letter-spacing: 0.015em;
  color: #8a8988;
  font-size: 14px;
  font-weight: 400;
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 16px;
    font-weight: 600;
  }
`;

const ModalDescription = styled.div`
  font-style: normal;
  max-width: 588px;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  margin-top: 16px;
  letter-spacing: 0.015em;
  color: #8a8988;
`;

const ListComponent = styled.ul`
  li {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    color: #434343;
    a {
      font-size: 14px;
    }
  }
  li:not(:first-child) {
    margin-top: 24px;
  }
`;

const CustomButton = styled.button<{ filled: boolean }>`
  border: none;
  display: flex;
  justify-content: center;
  font-weight: 600;
  height: 52px;
  background: ${(prop) =>
    prop.filled ? themeDefault.colors.primary : themeDefault.colors.white};
  align-items: center;
  text-align: center;
  transition: all 0.2s linear;
  color: ${(prop) =>
    prop.filled ? themeDefault.colors.white : themeDefault.colors.primary};
  cursor: pointer;
  border: 1px solid #883e89;
  border-radius: 100px;
  max-width: 295px;
  width: 100%;
  @media (hover: hover) {
    &:hover {
      background: #883E89;
      color: #ffffff;
    }
  }

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: 180px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 24px;
  flex-direction: column;
  width: 100%;
  align-items: center;

  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    flex-direction: row;
  }
`;

function Declaration() {
  const history = useHistory();
  const resetStore = useReduxReset();
  const dispatch = useAvivaDispatch();
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const basicDetails = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  const myInfoForm: any = useAvivaSelector((state) => state.shieldStarterStep3);
  // const WhomTobuy = useAvivaSelector(
  //   (state) => state.shieldStarterStep1.whomToBuy
  // );
  // const mySelfDateOfBirth = useAvivaSelector(
  //   (state) => state.shieldStarterStep3.personalInfo?.dateOfBirth
  // );
  const selectedPolicy = useAvivaSelector(
    (state) => state.shieldStarterStep2.policyName
  );
  // const isChild = WhomTobuy === "child" ? true : false;
  // const [isJuvinal, setIsJuvinal] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const DeclarationRef = useRef<null | HTMLDivElement>(null);
  const SpacerRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (
      isEmpty(basicDetails) ||
      isEmpty(myInfoForm?.personalInfo) 
    ) {
      resetStore();
      history.push(ROUTE_PATH.SHIELD_STARTER_GET_QUOTE);
      return;
    }

    if (DeclarationRef.current) {
      DeclarationRef.current.style.opacity = "1";
      calculateSpacer(DeclarationRef, SpacerRef, true);
    }
  }, []);

  // function calculate_age(date_of_birth: string) {
  //   const dob = new Date(date_of_birth);
  //   const differenceInMilliSecond = Date.now() - dob.getTime();
  //   const differenceDate = new Date(differenceInMilliSecond);
  //   return Math.abs(differenceDate.getUTCFullYear() - 1970);
  // }

  // useEffect(() => {
  //   //check for juvinal age group
  //   if (!isChild) {
  //     const age = calculate_age(mySelfDateOfBirth);
  //     if (age >= 17 && age <= 21) setIsJuvinal(true);
  //   }
  // }, [isChild, mySelfDateOfBirth]);

  useEffect(() => {
    //TODO: Added the tracking on load in else block when goBack condition is checked if the user hiting the url directly
    trackOnLoad("sss_health_declaration_terms_page");
  }, []);

  return (
    <>
      <div ref={DeclarationRef}>
        <MainContainer
          step={4}
          backButtonPath={ROUTE_PATH.SHIELD_STARTER_HEALTH_DECLARATION}
        >
          <Card padding="0" marginTop="0" opacityValue="uset">
            <Header>Declaration</Header>
            <Description>
              Please ensure that you have clicked on the links and read
              <br /> all documents fully before making your declaration.
            </Description>
            <Card
              padding={"24px 64px"}
              opacityValue="uset"
              backgroundColor="none"
              marginTop="0"
            >
              <ListComponent>
                <li>
                  I have read and understood the{" "}
                  <Link
                    target="blank"
                    text="Product Summary"
                    url={
                      selectedPolicy === SHIELD_STARTER_HELTH_PLUS
                        ? PRODUCT_SUMMARY_SHIELD_STARTER_HEALTH_PLUS
                        : PRODUCT_SUMMARY_SHIELD_STARTER
                    }
                    variant="link"
                  />{" "}
                  including any coverage exclusion stated in the Product
                  Summary.
                </li>
                <li>
                  I have downloaded, fully read and understood the{" "}
                  <Link
                    target="blank"
                    text="Policy Terms & Conditions"
                    url={
                      selectedPolicy === SHIELD_STARTER_HELTH_PLUS
                        ? TERMS_AND_CONDITION_SHIELD_STARTER_HEALTH_PLUS
                        : TERMS_AND_CONDITION_SHIELD_STARTER
                    }
                    variant="link"
                  />
                  .
                </li>
                <li>
                  I have read and agreed to the statements described in the{" "}
                  <Link
                    target="blank"
                    text="Declaration Document"
                    url={SHIELD_STARTER_DECLARATION_LINK}
                    variant="link"
                  />
                  .
                </li>
                <li>
                  I have completed and disclosed fully and truthfully all the
                  information requested for in this application.
                </li>
                <li>
                  I understand that any misrepresentation or concealment of
                  facts shall render the policy to be issued and any other
                  policy which I have with Singlife to which the information
                  applies null and void.
                </li>
                <li>
                  I am purchasing this plan without any advice from a financial
                  adviser representative and I take responsibility to ensure
                  that this plan suits my needs.
                </li>
                <li>
                  I understand that I will receive my policy, any endorsements and
                  communications electronically once they are ready. I understand
                  that I may log on to MySinglife to opt for my preferred document
                  option and may switch between e-documents and printed documents.
                </li>

                {/* TODO : Age calculate to add the point */}
                {/* {isJuvinal && (
                  <li>
                    I am between 17 to 21 Age Next Birthday and Singlife will
                    request for my parent’s approval for my application.
                  </li>
                )} */}
              </ListComponent>
              <ButtonContainer>
                <CustomButton
                  filled={false}
                  onClick={() => {
                    setIsShowModal(true);
                  }}
                >
                  I do not agree
                </CustomButton>
                <CustomButton
                  filled={true}
                  onClick={() => {
                    dispatch(updateDeclaration(true));
                    if(campaignDetail) {
                      history.push(ROUTE_PATH.SHIELD_STARTER_REVIEW);
                    } else {
                      history.push(ROUTE_PATH.SHIELD_STARTER_ADVISER);
                    }
                  }}
                >
                  Agree to all
                </CustomButton>
              </ButtonContainer>
            </Card>
          </Card>
        </MainContainer>
      </div>
      <DeclarationModal
        onClose={() => {
          setIsShowModal(false);
        }}
        showModal={isShowModal}
      >
        <>
          <Header marginTop={"0"}>Need help with your declaration?</Header>
          <ModalDescription>
            If you have any concerns or need help with any part of the
            declaration, please contact us and we'll help you out.
          </ModalDescription>
          <ButtonContainer>
            <CustomButton
              filled={false}
              onClick={() => {
                setIsShowModal(false);
              }}
            >
              Back
            </CustomButton>
            <CustomButton
              filled={true}
              onClick={() => {
                // dispatch(updateDeclaration(true));
                history.push(ROUTE_PATH.SHIELD_STARTER_CONTACT_US);
              }}
            >
              Contact us{" "}
            </CustomButton>
          </ButtonContainer>
        </>
      </DeclarationModal>
      <div ref={SpacerRef}></div>
    </>
  );
}
export default Declaration;
